/**
 * Kontekst konta, w którym karta integracji czyta status i wykonuje akcje.
 *
 * Domyślnie integracje agencji jadą w kontekście wybranego klienta (`forUserId`).
 * Wyjątkiem są integracje, których podpięcie zawsze ląduje na koncie zalogowanego
 * usera — dla nich odpytywanie kontekstu klienta pokazuje „Nie połączono" mimo
 * poprawnie zapisanej integracji (VP-317).
 */

/**
 * Shopify: claim sklepu (`POST /api/integrations/shopify/claim`) zapisuje integrację
 * na `req.user.id` i nie przyjmuje `forUserId`. Agencja z jednym klientem ma go
 * auto-wybranego (useAgencyClients), więc hub pytał o konto klienta i sklep „znikał"
 * zaraz po komunikacie „Sklep podpięty". Gdy claim nauczy się przyjmować klienta
 * docelowego, ten wyjątek znika.
 *
 * Cena tej decyzji: cała karta (status, instalacja, rozłączenie) jedzie jednym kontem,
 * więc integracja podpięta kiedyś klientowi przez `?forUserId` nie jest widoczna ani
 * zarządzalna z huba. Na prodzie takich nie ma (jedyne wiersze to konta ownerów),
 * a karta Shopify jest za whitelistą testerów — świadomy tradeoff do czasu, aż na
 * ekranie claimu pojawi się wybór klienta docelowego. Panel mówi o tym wprost
 * (`connectPanels.shopify.ownAccountScope`), żeby nikt nie podpinał sklepu w ciemno.
 */
export const SELF_SCOPED_INTEGRATIONS: ReadonlySet<string> = new Set<string>(["shopify"]);

/** `null` = konto zalogowanego usera; string = konto klienta agencji. */
export function scopeForIntegration(
  integrationId: string,
  forUserId: string | null | undefined
): string | null {
  if (SELF_SCOPED_INTEGRATIONS.has(integrationId)) return null;
  return forUserId ?? null;
}
